import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=12b4c3e0&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&async=true&lang=js&"
export * from "./MyOrders.vue?vue&type=script&async=true&lang=js&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=12b4c3e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4c3e0",
  null
  
)

export default component.exports